import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { motion } from 'framer-motion';
import { useNavigate, useParams } from 'react-router-dom';

const BuyerDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div className="flex items-center space-x-4">
        <button
          onClick={() => navigate('/buyers')}
          className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
        >
          <ArrowLeftIcon className="w-6 h-6" />
        </button>
        <div>
          <h1 className="text-3xl font-display font-bold text-gray-900">
            Buyer Details #{id}
          </h1>
          <p className="text-gray-600 mt-2">
            View detailed information about this buyer
          </p>
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white rounded-xl p-8 shadow-soft border border-gray-200 text-center"
      >
        <h3 className="text-lg font-medium text-gray-900 mb-2">Coming Soon</h3>
        <p className="text-gray-600">
          Detailed buyer profile with purchase history, preferences, and activity analytics.
        </p>
      </motion.div>
    </div>
  );
};

export default BuyerDetails;